import Header from './components/Header';
import Hero from './components/Hero';
import UpdatesSection from './components/UpdatesSection';
import RankingSection from './components/RankingSection';
import CarouselSection from './components/CarouselSection';
import AppSection from './components/AppSection';
import IndexSection from './components/IndexSection';
import AboutSection from './components/AboutSection';
import TopicsSection from './components/TopicsSection';
import ContactSection from './components/ContactSection';
import FaqSection from './components/FaqSection';
import CommentsSection from './components/CommentsSection';
import FeaturesSection from './components/FeaturesSection';
import MediaSection from './components/MediaSection';
import CardsSection from './components/CardsSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50 text-foreground-200 font-body">
      <Header />
      <main>
        <Hero />
        <UpdatesSection />
        <RankingSection />
        <CarouselSection />
        <AppSection />
        <IndexSection />
        <AboutSection />
        <TopicsSection />
        <ContactSection />
        <FaqSection />
        <CommentsSection />
        <FeaturesSection />
        <MediaSection />
        <CardsSection />
      </main>
      <Footer />
    </div>
  );
}